//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../no/Session.js";
let d=[[],[[["part"],"DisplayPartHistory",{},1,0],[["point"],"DisplayPointDetails",{},1,0],[["absolute_point_coordinates"],"DisplayPointDetailsUsingPoint3d",{},1,0],[["selected_objects"],"DisplayObjectsDetails",{},1,0],[["feature","type"],"DisplayFeatureDetails",{},2,0],[["part"],"DisplayInterpartChildren",{},1,0],[["part"],"DisplayInterpartParents",{},1,0],[["part"],"DisplayUpdateStatusReport",{},1,0],[["selected_objects"],"DisplayCamObjectsDetails",{},1,0],[["selected_objects","start_counter"],"DisplayProdIntObjectsDetails",{},2,0]],[]];
SPLM.Information = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Information";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Information.DisplayFeatureType = Object.freeze({
    "All" : "All", "Expressions" : "Expressions", "Parameters" : "Parameters", "Dependencies" : "Dependencies", "FeaturesInBody" : "FeaturesInBody", "RelatedObject" : "RelatedObject"});

export default SPLM;